import {useEffect} from "react";
import {useTranslation} from "react-i18next";
import {CameraIcon3} from "./icons/CameraIcon3";
import {useDispatch} from "react-redux";
import {requestCameraPermission} from "../store/verification.slice";
import Header from "./reusable/Header";
import {Button} from "@nextui-org/react";
import PoweredBy from "./reusable/PoweredBy";
import {trackEvent} from "../utils/analytics";

const reasons = ["document", "selfie", "privacy"];
const reasonEmojis = {
    document: "🪪",
    selfie: "🤳",
    privacy: "🔒",
};

function Permission({flowId, metadata, clientId}) {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    useEffect(() => {
        trackEvent("camera_permission_prompt_viewed", { flowId });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleRequestPermission = () => {
        trackEvent("camera_permission_requested", { flowId });
        dispatch(requestCameraPermission(flowId, metadata, clientId));
    };

    return (
        <div className="h-full flex flex-col">
            <Header/>
            <div className="flex flex-col p-5 h-full justify-between">

                {/* Icon + heading */}
                <div className="flex flex-col items-center text-center gap-2">
                    <div className="flex items-center justify-center rounded-full border icon-badge-bg p-4">
                        <CameraIcon3 height={56} width={56} stroke="var(--urtentic-sdk-primary, #255CFF)"/>
                    </div>
                    <div className="heading text-2xl">{t("permission.heading")}</div>
                    <div className="desc text-sm leading-relaxed" style={{color: "var(--urtentic-sdk-subtitle, #737373)"}}>
                        {t("permission.description")}
                    </div>
                </div>

                {/* Reasons */}
                <div className="flex flex-col gap-1">
                    <div
                        className="text-xs font-semibold uppercase tracking-widest mb-2 text-center"
                        style={{color: "var(--urtentic-sdk-body, #737373)"}}
                    >
                        {t("permission.reasonsTitle")}
                    </div>
                    {reasons.map((reasonKey) => (
                        <div
                            key={reasonKey}
                            className="flex flex-row items-start gap-3 p-3 rounded-lg background"
                        >
                            <span className="text-base shrink-0 mt-0.5">{reasonEmojis[reasonKey]}</span>
                            <div className="desc text-sm leading-relaxed">{t(`permission.reasons.${reasonKey}`)}</div>
                        </div>
                    ))}
                </div>

                {/* CTA */}
                <div className="flex flex-col items-center gap-2">
                    <Button
                        fullWidth
                        radius="sm"
                        color="primary"
                        size="lg"
                        onClick={handleRequestPermission}
                    >
                        {t("permission.cta")}
                    </Button>
                    <p className="desc text-center text-xs px-2">
                        {t("permission.deniedHint")}
                    </p>
                    <PoweredBy/>
                </div>

            </div>
        </div>
    );
}

export default Permission;
